module.exports = __webpack_public_path__ + "img/WS.029b825c.svg";